import { createStore } from "vuex";
import persistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
import wsManager from '@/utils/websocket/WebSocketManager';
var ls = new SecureLS({ isCompression: false });
const encryptionService = {
  secretKey: "your-encryption-key", // 实际项目中使用环境变量

  // 加密数据
  encrypt: function (data) {
    return ls.AES.encrypt(JSON.stringify(data), this.secretKey).toString();
  },

  // 解密数据
  decrypt: function (encryptedData) {
    if (!encryptedData) return null;
    const bytes = ls.AES.decrypt(encryptedData, this.secretKey);
    return JSON.parse(bytes.toString(ls.enc._Utf8));
  },
};
export default createStore({
  state: {
    token: {
      access_token: "",
      expire_time: 0,
      refresh_token: "",
    },
    chatToken: {
      access_token: "",
      expire_time: 0,
      refresh_token: "",
    },
    userInfo: null as any,
    systemConfig:{
        fileUrl:'',
        ossFileUrl:'',
        head:'',
        imApiUrl:'',
        imWsUrl:'',
        minWithMoney:0,
        chatFirstMsg:''
    },
    activeMenu: {
      path: "",
      name: "",
    },
    areaData: [] as any,
    emojiList: [] as any,
    emoji: {
      url: "",
      map: [] as any,
      visible: false,
      decoder: null as any,
    },
    chatTell: [] as any,
    sessionData:{
        last_time: null as any,
        data:[] as any
    }
  },
  getters: {},
  mutations: {
    activeMenu(state: any, value: any) {
      state.activeMenu = value;
    },
    areaData(state: any, value: any) {
      state.areaData = value;
    },
    chatTell(state: any, value: any) {
      state.chatTell = value;
    },
    SYSTEM_CONFIG(state: any, value: any) {
        state.systemConfig = value;
    },
    LOGIN_CHAT(state: any, value: any) {
      state.chatToken.access_token = value.access_token;
      state.chatToken.expire_time = value.expire_time;
    },
    LOGIN_IN(state: any, value: any) {
      state.token.access_token = value.token.access_token;
      state.userInfo = value.userInfo;
      state.systemConfig = value.systemConfig;
    },
    EDIT_USERINFO(state: any, value: any) {
      state.userInfo = value;
    },
    LOGIN_OUT(state: any) {
      state.userInfo = null;
      state.token.access_token = "";
      state.chatToken.access_token = "";
      state.chatToken.expire_time = 0;
      state.sessionData.last_time = null;
      state.sessionData.data = [];
      state.systemConfig = {};
      wsManager.close();
      window.sessionStorage.removeItem("vuex");
      window.sessionStorage.clear();
    },
    SET_EMOJI_LIST(state: any, value: any) {
      state.emojiList = value;
    },
    sessionData(state: any, value: any){
        state.sessionData.last_time = new Date().getTime();
        state.sessionData.data = value;
    },
  },
  actions: {
  },
  modules: {},
  plugins: [
    persistedState({
      storage: {
        setItem: (key, value) => {
          const encrypted = encryptionService.encrypt(value);
          sessionStorage.setItem(key, encrypted);
        },
        getItem: (key) => {
          const data = sessionStorage.getItem(key);
          return data ? encryptionService.decrypt(data) : null;
        },
        removeItem: (key) => {
          sessionStorage.removeItem(key);
        },
      },
    }),
  ],
});
